class SchedulesService {
  static base = '/schedules';

  static getSlots = (eventPointId, date) =>
    `${this.base}?event_point_id=${eventPointId}&date=${date}`;
}

export default SchedulesService;
